
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, string_type, anonRecord_type, class_type, record_type, int32_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import { nativeType, useDrop, useDrag } from "../../Bindings/Fable.ReactDnD.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { comparePrimitives, stringHash, defaultOf, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { sortBy, filter, mapIndexed as mapIndexed_1, toArray, map, cons, length, contains, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { useTranslation } from "react-i18next";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { choose, insertAt, mapIndexed, item as item_1, equalsWith } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextButton } from "../../Components/Button.js";

export class DragItem extends Record {
    constructor(Index) {
        super();
        this.Index = (Index | 0);
    }
}

export function DragItem_$reflection() {
    return record_type("Widgets.Image.ImageUploadDnD.DragItem", [], DragItem, () => [["Index", int32_type]]);
}

export class DnDFormImage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["File", "ImageUrl"];
    }
}

export function DnDFormImage_$reflection() {
    return union_type("Widgets.Image.ImageUploadDnD.DnDFormImage", [], DnDFormImage, () => [[["Item", anonRecord_type(["File", class_type("Browser.Types.File", undefined)], ["Position", int32_type])]], [["Item", anonRecord_type(["ImageUrl", string_type], ["Position", int32_type])]]]);
}

export function DnDFormImage__get_Position(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Position | 0;
    }
    else {
        return this$.fields[0].Position | 0;
    }
}

export function ImagePreview(props) {
    let elems_1, elems;
    const patternInput = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => (new DragItem(props.Index)),
        type: "imagePreview",
    });
    const patternInput_1 = useDrop({
        accept: "imagePreview",
        collect: (monitor_1) => {
            const isOver = monitor_1.isOver();
            return {
                canDrop: monitor_1.canDrop(),
                isOver: isOver,
            };
        },
        drop: (value) => {
        },
        hover: (item) => {
            const dragItem = item;
            if (dragItem.Index !== props.Index) {
                props.MoveImage(dragItem.Index, props.Index);
                item.Index = props.Index;
            }
        },
    });
    return reactElement("div", createObj(ofArray([["ref", (element) => {
        patternInput_1[1](element);
        patternInput[1](element);
    }], ["className", join(" ", ["relative"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "top-2", "right-2", "h-5", "w-5", "p-1", "rounded-full", "text-red", "bg-background", "cursor-pointer"])], ["onClick", (event) => {
        event.preventDefault();
        props.RemoveImage();
    }], (elems = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("img", {
        className: join(" ", ["shadow", "rounded", "border", "w-24", "h-20", "object-cover"]),
        src: props.ImageUrl,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ImageUpload(props) {
    let copyOfStruct, elems_3, elems_2, elems, Label, elems_1;
    const patternInput = useTranslation();
    const fileUploadId = concat("file-upload-", ...((copyOfStruct = newGuid(), copyOfStruct)));
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, testExpr_1;
            const matchValue = draggedFile.files;
            if (matchValue == null) {
            }
            else if ((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) {
            }
            else if ((testExpr_1 = matchValue, !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 1))) {
                const file = item_1(0, matchValue);
                if (contains(file.type, ofArray(["image/jpeg", "image/png"]), {
                    Equals: (x_2, y_2) => (x_2 === y_2),
                    GetHashCode: (x_2) => (stringHash(x_2) | 0),
                }) && (length(props.SelectedFiles) < 5)) {
                    props.SetSelectedFile(cons(new DnDFormImage(0, [{
                        File: file,
                        Position: length(props.SelectedFiles) + 1,
                    }]), props.SelectedFiles));
                }
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("rounded"), delay(() => append(singleton("border"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => append((dropData.isOver && dropData.canDrop) ? singleton("bg-background") : singleton("bg-white"), delay(() => append(singleton("p-4"), delay(() => singleton("flex-col"))))))))))))))))], ["ref", patternInput_1[1]], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("gap-4"), delay(() => ((length(props.SelectedFiles) > 0) ? singleton("mb-2") : empty()))))))))], (elems = toList(delay(() => map((selectedFile) => {
        let Index;
        return createElement(ImagePreview, (Index = (DnDFormImage__get_Position(selectedFile) | 0), {
            ImageUrl: (selectedFile.tag === 1) ? selectedFile.fields[0].ImageUrl : URL.createObjectURL(selectedFile.fields[0].File),
            Index: Index,
            MoveImage: (fromIndex, toIndex) => {
                const files = toArray(props.SelectedFiles);
                props.SetSelectedFile(ofArray(mapIndexed((index_1, file_2) => {
                    if (file_2.tag === 1) {
                        return new DnDFormImage(1, [{
                            ImageUrl: file_2.fields[0].ImageUrl,
                            Position: index_1 + 1,
                        }]);
                    }
                    else {
                        return new DnDFormImage(0, [{
                            File: file_2.fields[0].File,
                            Position: index_1 + 1,
                        }]);
                    }
                }, insertAt(toIndex - 1, item_1(fromIndex - 1, files), choose((x_3) => x_3, mapIndexed((index, file_1) => {
                    if (index === (fromIndex - 1)) {
                        return undefined;
                    }
                    else {
                        return file_1;
                    }
                }, files))))));
            },
            RemoveImage: () => {
                props.SetSelectedFile(mapIndexed_1((index_2, file_6) => {
                    if (file_6.tag === 1) {
                        return new DnDFormImage(1, [{
                            ImageUrl: file_6.fields[0].ImageUrl,
                            Position: index_2 + 1,
                        }]);
                    }
                    else {
                        return new DnDFormImage(0, [{
                            File: file_6.fields[0].File,
                            Position: index_2 + 1,
                        }]);
                    }
                }, filter((file_5) => (DnDFormImage__get_Position(file_5) !== DnDFormImage__get_Position(selectedFile)), props.SelectedFiles)));
            },
        }));
    }, sortBy((_arg) => (DnDFormImage__get_Position(_arg) | 0), props.SelectedFiles, {
        Compare: (x_4, y_3) => (comparePrimitives(x_4, y_3) | 0),
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextButton, (Label = patternInput[0]("file_upload.select_image_max_5"), {
        ComponentState: (length(props.SelectedFiles) >= 5) ? "disabled" : props.ComponentState,
        Label: Label,
        OnClick: () => {
            const element = document.getElementById(fileUploadId);
            element.click();
        },
        TestId: "open-file-explorer-test-id",
        Variant: "blueButton",
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_1 = [reactElement("input", {
        id: fileUploadId,
        className: join(" ", ["hidden"]),
        type: "file",
        accept: ".jpg, .jpeg, .png",
        onChange: (ev) => {
            const files_1 = ev.target.files;
            if (!(files_1 == null) && (files_1.length > 0)) {
                props.SetSelectedFile(cons(new DnDFormImage(0, [{
                    File: files_1.item(0),
                    Position: length(props.SelectedFiles) + 1,
                }]), props.SelectedFiles));
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

